import React from 'react';
import { memo } from 'react';
import { SizeTypeTokens, SpaceOrientation, } from '@voltmoney/schema';
import { View } from 'react-native';
import ThemeProvider from '@voltmoney/theme';
const Space = ({ size = SizeTypeTokens.XS, orientation = SpaceOrientation.ALL, }) => {
    const theme = ThemeProvider.getTheme();
    const sizeValue = theme.space[size] || 0;
    switch (orientation) {
        case SpaceOrientation.HORIZONTAL:
            return (React.createElement(View, { style: {
                    width: sizeValue,
                } }));
        case SpaceOrientation.VERTICAL:
            return (React.createElement(View, { style: {
                    height: sizeValue,
                } }));
        default:
            return (React.createElement(View, { style: {
                    width: sizeValue,
                    height: sizeValue,
                } }));
    }
};
export default memo(Space);
export { Space };
